import { ADD_TO_CART } from "../actionTypes";

export const AddItemToCart = data => ({
    type: ADD_TO_CART,
    payload: data,
});